(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-carousel/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-carousel/assets/javascripts/init.js');

'use strict';

svs.banner_groups.banner_carousel.init = options => {
  const $el = options.$el;
  if ($el && $el.length > 0) {
    new svs.banner_common.banner_helpers.Form($el);
    const $carousels = $el.find('.js-ui-carousel');
    if ($carousels.length > 0) {
      const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
      $carousels.each((_, item) => {
        var _item$closest;
        if ((_item$closest = item.closest('.widget')) !== null && _item$closest !== void 0 && (_item$closest = _item$closest.nextSibling) !== null && _item$closest !== void 0 && _item$closest.querySelector('.category-menu-widget')) {
          item.classList.add('banner-carousel-bottom-padding');
        }
        svs.components.tbUi.carousel.createCarouselHandler(item, shouldReduceMotion);
      });
    }
  }
};

 })(window);